/**
 * @generated SignedSource<<29644d2a5832b974b172768248eef468>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedInteriorsHeader_itemSearch$data = {
  readonly pageType: string | null;
  readonly meta: {
    readonly attributeDisplayName: string | null;
  } | null;
  readonly " $fragmentType": "SbSharedInteriorsHeader_itemSearch";
};
export type SbSharedInteriorsHeader_itemSearch$key = {
  readonly " $data"?: SbSharedInteriorsHeader_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedInteriorsHeader_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedInteriorsHeader_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "attributeDisplayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "7f26cbfa91e21d3464f78e9790cc0305";

export default node;
